import React from "react";

import { User } from "../../../../types";
import CardsViewShell from "../../../../components/views/cards-view-shell";
import { TeamSummary } from "../../../../types.new";
import UserCard from "./user-card";
import { sortUsers } from "../../../../utils/sort-users";

interface UsersCardsViewProps {
  team: TeamSummary;
  filteredUsers: User[];
  unfilteredUsersCount: number;
  canEdit: boolean;
}

const UsersCardsView: React.FC<UsersCardsViewProps> = ({
  team,
  filteredUsers,
  unfilteredUsersCount,
  canEdit,
}) => {
  return (
    <CardsViewShell
      shownCount={filteredUsers.length}
      totalCount={unfilteredUsersCount}
    >
      {[...filteredUsers].sort(sortUsers).map((user) => (
        <UserCard
          key={user.userId}
          user={user}
          team={team}
          canEdit={canEdit}
        />
      ))}
    </CardsViewShell>
  );
};

export default UsersCardsView;
